import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { Value } from "@wojtekmaj/react-daterange-picker/dist/cjs/shared/types";

import { downloadAllDriversDeliveriesReport } from "../../helpers";
import { requestDriversDeliveriesReport } from "./getDriversDeliveriesReport.request";
import { GetDriversDeliveriesReportRequestParams } from "./getDriversDeliveriesReport.types";

/**
 * The report is only ever printed, never rendered on screen, so it is a
 * mutation: the deliveries of every driver are fetched on click and handed
 * straight to the PDF builder.
 */
const useGetDriversDeliveriesReport = (
  params: GetDriversDeliveriesReportRequestParams,
  dateRange: Value
) =>
  useMutation({
    mutationFn: async () => await requestDriversDeliveriesReport(params),
    onSuccess: (items) =>
      downloadAllDriversDeliveriesReport(items, dateRange),
    onError: toastServerError
  });

export default useGetDriversDeliveriesReport;
